<template>
  <gj-modal
      :visible.sync="modalVisible"
      @cancel="cancel"
      @confirm="confirm"
      :confirm-loading="confirmLoading"
      :loading="detailLoading"
      :content-style="{'height':'100%', 'display':'flex','flex-direction':'column'}"
  >
    <template #header>开始盘点{{item.code}}</template>
    <template #content>

        <gj-desc-group style="margin-bottom: 24px" label-width="100px">
          <el-row>
            <el-col :span="8">
              <gj-desc label="盘点仓">{{form.warehouseName | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="创建人">{{form.createUserName | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="创建时间">{{form.createTime | defaultShow}}</gj-desc>
            </el-col>
          </el-row>
          <div>
            <gj-desc label="备注">
              <div style="display: inline-block">
                <div :hidden="!memoFlag" style="cursor: pointer"
                     @click="clickEditMemo">
                  {{memo}}
                  <i class="el-icon-edit" style="margin-left: 10px"></i></div>
                <div :hidden="memoFlag">
                  <gj-textarea
                      ref="memoInput"
                      @blur="memoBlur"
                      :styles="{height: '32px', width: '300px'}"
                      v-model="memo"
                  >
                  </gj-textarea>
                </div>
              </div>
            </gj-desc>
          </div>
        </gj-desc-group>
        <div style="margin-bottom: 12px">
          <gj-button type="primary" @click="importResult">导入结果</gj-button>
          <gj-button type="primary" @click="downloadStorageTpl">下载盘点清单</gj-button>
        </div>

        <el-form ref="form" :model="form" style="flex: 1;overflow: auto">
          <gj-base-table
            ref="gjTable"
            class="start-count"
            :list="form.items"
            :columns="columns"
            :loading="loading"
            highlight-hover-row
            :pagerConfig="pagination"
            isFormat
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
            <template v-slot:productInfo="{row}">
              <div>
                <gj-text width="100%" :content="row.productName">{{row.productName}}</gj-text>
              </div>
              <div>
                <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
              </div>
            </template>
            <template v-slot:realGoodProduct="{row,rowIndex}">
              <el-form-item
                class="not-form-item-mgb gj-table-item "
                :prop="`items.${rowIndex}.actualQuantity`"
                :rules="[
                  $gjRequired('请输入实际良品量'),
                  $gjReRule(RE.pt0, '请输入0或正整数')
                ]">
                <gj-input v-model="form.items[rowIndex].actualQuantity" @focus="onFocus(form.items[rowIndex].actualQuantity,rowIndex,1)" @blur="updateStorageItem(row,form.items[rowIndex].actualQuantity,rowIndex,1)"></gj-input>
              </el-form-item>
            </template>
            <template v-slot:realDefective="{row,rowIndex}">
              <el-form-item
                class="not-form-item-mgb gj-table-item "
                :prop="`items.${rowIndex}.actualBadQuantity`"
                :rules="[
                  $gjRequired('请输入实际次品量'),
                  $gjReRule(RE.pt0, '请输入0或正整数')
                ]">
                <gj-input v-model="form.items[rowIndex].actualBadQuantity" @focus="onFocus(form.items[rowIndex].actualBadQuantity,rowIndex,2)" @blur="updateStorageItem(row,form.items[rowIndex].actualBadQuantity,rowIndex,2)"></gj-input>
              </el-form-item>
            </template>
            <template v-slot:memo="{row,rowIndex}">
              <el-form-item
                  class="not-form-item-mgb gj-table-item "
                  :prop="`items.${rowIndex}.memo`">
                <gj-input v-model="form.items[rowIndex].memo" width="140px" placeholder="备注" @focus="onFocus(form.items[rowIndex].memo,rowIndex,3)" @blur="updateStorageItem(row,form.items[rowIndex].memo,rowIndex,3)"></gj-input>
              </el-form-item>
            </template>
          </gj-base-table>
        </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn, queryMixin, responseMixin} from "@/minxins";
  import AppImportResult from './import-result';
  import {
    getStorageCheckDetail,
    getStorageCheckDetailPage,
    startCounting, updateStorageCheckItem,
    updateStorageCheckMemo
  } from "@/api/warehouse";
  import {exportFile} from "@/api/common";
  import {ProductEnum} from "@/utils/options";

  export default {
    name: "start-counting",
    mixins: [modalMixIn, formRuleMixin, queryMixin, responseMixin],
    props: {
      item: null
    },
    created() {
      getStorageCheckDetail(this.item.id)
        .then((data) => {
          this.form.warehouseName = data.warehouseName;
          this.form.createUserName = data.createUserName;
          this.form.createTime = data.createTime;
          this.memo = data.memo;
        }).complete(() => this.detailLoading = false);
      this.$gjQuery();
    },
    data() {
      return {
        detailLoading: false,
        confirmLoading: false,
        memoFlag: true,
        memo: '',
        form: {
          warehouseName: null,
          createUserName: null,
          createTime: null,
          items: [],
        },
        columns: [
          {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '200px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '100px', options: ProductEnum.typeOption},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', minWidth: '100px', align: 'right'},
          {id: 'goodProduct', header: '库存良品量', field: 'currentQuantity', minWidth: '100px', align: 'right'},
          {id: 'defective', header: '库存次品量', field: 'currentBadQuantity', minWidth: '100px', align: 'right'},
          {id: 'realGoodProduct', header: '实际良品量', field: 'slot:realGoodProduct', required: true, minWidth: '120px'},
          {id: 'realDefective', header: '实际次品量', field: 'slot:realDefective', required: true, minWidth: '120px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '150px'},
        ],
        debounceUpdate: this._.debounce(this.updateStorageItem, 500),

        //输入框唯一标识符=值+index+type
        identifier:'',
        //是否正在调用数据修改接口
        isChanging:false
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        getStorageCheckDetailPage({
          model: {
            checkId: this.item.id
          },
          ...this.querySort,
          ...this.queryPagination,
        }).then((data) => {
          this.form.items = data.records;
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      clickEditMemo() {
        this.memoFlag = false;
      },
      memoBlur() {
        updateStorageCheckMemo(this.item.id, this.memo)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$message.success('保存成功');
            })
          });
        this.memoFlag = true;
      },
      importResult() {
        this.$gjCreate(AppImportResult, {
          props: {
            id: this.item.id
          },
          on: {
            importSuccess: () => {
              this.$gjNoticeQuery();
            }
          }
        })
      },
      downloadStorageTpl() {
        exportFile(`/supply/storageCheck/downloadCheckResultTemplate?id=${this.item.id}`, {})
      },
      onFocus(value, index, type){
        //聚焦时，记录输入框唯一标识符=值+index+type
        this.identifier = value+','+index+','+type;
      },
      updateStorageItem(row, value, index, type) {
        //失焦时，若输入框唯一标识符改变，则调用修改数据接口
        if(this.identifier !== value+','+index+','+type){
          //记录调用中状态
          this.isChanging = true
          updateStorageCheckItem({id: row.id, memo: row.memo,
            actualBadQuantity: row.actualBadQuantity, actualQuantity: row.actualQuantity,})
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('自动保存成功');
                })
              }).complete(()=>{
                //记录调用完成状态
                this.isChanging = false
              })
        }
      },
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          //验证通过后，启用定时器
          let confirm = setInterval(() => {
            //若修改接口调用中，则跳出
            if (this.isChanging) {
              return
            }
            //若修改接口调用完成，则清除定时器，继续原有逻辑
            clearInterval(confirm)
            startCounting(this.item.id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$emit('after');
                  })
                }).complete(() => {
                  this.confirmLoading = false;
                }
            )
          }, 100)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  /deep/ .el-dialog__body{
    padding: 8px 20px 0 20px;
  }
  .start-count{
    /deep/ tr.vxe-body--row{
      height: 64px;
    }
    /deep/ .el-input{
      z-index: 1;
    }
   ///deep/ .col--ellipsis {
    /deep/  .gj-table-item .el-form-item__error{
      z-index: 0;
       margin-top: -16px;
     }
    //}
  }

</style>
